import { onError } from '@apollo/client/link/error'
import rollbar from '@cred/shared/rollbar'
import { configureRollbar, isE2EMode } from '../../../utils'
import config from 'config'

function getLoginRedirectLink(cookies, { redirect }) {
  if (isE2EMode()) {
    return onError(() => {}) // No redirect to allow mock requests for e2e testing purposes on CI @sinslav
  }
  return onError(({ response, graphQLErrors }) => {
    if (graphQLErrors) {
      const email = cookies.get('email')

      if (email) {
        configureRollbar(decodeURIComponent(email))
      }

      graphQLErrors.map(({ message, path }) => {
        if (['Unauthorized', 'NoToken', 'TokenExpired'].includes(message)) {
          rollbar.error(`[Login Redirect] user redirected to loginUrl - resolver: ${path}`, {
            cookies: cookies.cookies
          })
          redirect(config.loginUrl)

          // Prevent errors from being thrown by Apollo.
          response.errors = null
        }
      })
    }
  })
}

export default getLoginRedirectLink
